import guests from 'assets/icons/Guests.svg';
import { Img, ImgSize } from 'shared/ui/imgStyledComponent';

type GuestsIconProps = {
	size?: ImgSize;
};

export const GuestsIcon: React.FC<GuestsIconProps> = ({ size }) => {
	return <Img role="image" src={guests} $size={size} />;
};
